<template>
  <div class="home-base">

    <!-- 头部 -->
    <div class="head" v-if="!hideHeaderFooter">

      <div class="h-t-b">
        <div class="h-t disf">
          <div class="l">Welcome to Gobuy !</div>
          <div class="r disf">
            <div class="username cup" v-if="user">
              <span style="color: #E2451A;">{{ user ? user.member_name : $t('Login') }}</span>
            </div>
            <div class="username cup" v-else>
              <router-link :to="{ name: 'HomeMemberLogin' }">
                <span style="color: #fff;">{{ $t('Login') }}</span>
              </router-link>
            </div>
            <div class="lang cup">
              <router-link :to="{ name: 'HomeLang' }">
                <span style="color: #fff;">{{ currentLang }}</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <div class="h-c disf">
        <div class="l cup">
          <router-link :to="{ name: 'HomeIndex' }">
            <img src="../../assets/image/logo.png" alt="logo">
          </router-link>
        </div>
        <div class="r">
          <div class="search">
            <div class="input">
              <input type="text" :placeholder="$t('EnterSearchContent')" readonly>
            </div>
            <div class="s-btn cup disf">
              <img src="../../assets/image/Search-btn.png" alt="Search-btn">
            </div>
          </div>
          <!-- <div class="s-tips">Free shipping for all customers price in stock</div> -->
        </div>
      </div>

      <div class="h-f disf">
        <div class="l disf">

          <div class="all cup disf" v-if="$route.name == 'HomeIndex'">
            <div class="icon">
              <img src="../../assets/image/fl.svg" alt="" />
            </div>
            <div class="text">{{ $t('All').toUpperCase() }} {{ $t('Category').toUpperCase() }}</div>

            <div class="category-list">
              <div class="category-item disf" v-for="(category, index) in items" :key="index"
                @click="goProduct(category.id, category.gc_name)">
                <div class="l">{{ category.value }}</div>
                <div class="r">></div>
              </div>
            </div>
          </div>

          <mt-tabbar v-model='home_selected' class="common-footer">
            <!-- 菜单 -->
            <mt-tab-item class='item-wrap' :class="{ 'active': $route.name == 'HomeIndex' }" id='home_index'>
              <router-link :to="{ name: 'HomeIndex' }" class='item'>
                <span class='text'>{{ $t('Home') }}</span>
              </router-link>
            </mt-tab-item>

            <mt-tab-item class='item-wrap'
              :class="{ 'active': $route.name == 'HomeGoodslist', 'category': $route.name == 'HomeGoodslist' }"
              id='home_goodsclass'>
              <router-link :to="{ name: 'HomeGoodslist' }" class='item'>
                <span class='text'> {{ $t('Category') }}</span>
              </router-link>

              <div class="category-list">
                <div class="category-item cup" v-for="(category, index) in items" :key="index"
                  @click="goProduct(category.id, category.gc_name)">
                  <div class="l">{{ category.value }}</div>
                </div>
              </div>
            </mt-tab-item>

            <!-- 分享 -->
            <mt-tab-item class='item-wrap' :class="{ 'active': $route.name == 'Shares' }" id='home_search'>
              <router-link :to="{ name: 'Shares' }" class='item'>
                <span class='text'>{{ $t('Share') }}</span>
              </router-link>
            </mt-tab-item>

            <!-- 礼品卡 -->
            <mt-tab-item class='item-wrap' :class="{ 'active': $route.name == 'GiftCardList' }" id='home_search'>
              <router-link :to="{ name: 'GiftCardList' }" class='item'>
                <span class='text'>{{ $t('MenuGiftCard') }}</span>
              </router-link>
            </mt-tab-item>

            <!-- 礼品卡回收 -->
            <mt-tab-item class='item-wrap' :class="{ 'active': $route.name == 'GiftSave' }" id='home_search'>
              <router-link :to="{ name: 'GiftSave' }" class='item'>
                <span class='text'>{{ $t('Recycle') }}</span>
              </router-link>
            </mt-tab-item>

            <!-- <mt-tab-item class='item-wrap' :class="{ 'active': $route.name == 'HomeCart' }" id='home_cart'>
              <router-link :to="{ name: 'HomeCart' }" class='item'>
                <span class='text'>{{ $t('Cart') }}</span>
                <span class="icon" v-if="cartNumber > 0">{{ getCarCount }}</span>
              </router-link>
            </mt-tab-item> -->

            <mt-tab-item class='item-wrap' :class="{ 'active': $route.name == 'MemberIndex' }" id='member_index'>
              <router-link :to="{ name: 'MemberIndex' }" class='item'>
                <span class='text'>{{ $t('Mine') }}</span>
              </router-link>
            </mt-tab-item>

            <!-- 新手指南 -->
            <mt-tab-item class='item-wrap' :class="{ 'active': $route.name == 'GuideIndex' }">
              <router-link :to="{ name: 'GuideIndex' }" class='item'>
                <span class='text'>{{ $t('guide.Rewards') }}</span>
              </router-link>
              <!-- <div class="guide-box">
                  <router-link :to="{ name: 'GuideIndex' }" class='category-item disf'>{{ $t('guide.title') }}</router-link>
                  <router-link :to="{ name: 'GuideInvite' }" class='category-item disf'>{{ $t('guide.Invitation.Reward') }}</router-link>
                  <router-link :to="{ name: 'GuideShare' }" class='category-item disf'>{{ $t('guide.Order.Sharing') }}</router-link>
              </div> -->
            </mt-tab-item>
          </mt-tabbar>
        </div>

        <router-link :to="{ name: 'HomeCart' }">
          <div class="r cup disf">
            <div class="icon">
              <img src="../../assets/image/my-cart.png" alt="my-cart">
            </div>
            <div class="text">{{ $t('my') }} {{ $t('Cart') }} ({{ getCarCount }})</div>
          </div>
        </router-link>
      </div>
    </div>

    <!-- 内容 -->
    <div class="layout-view">
      <router-view class="home-view" />
    </div>

    <!-- 侧边栏 -->
    <!-- <div class="sidebar">
      <div class="s1">
        <div class="sidebar-item cup">
          <img src="../../assets/image/kf.png" alt="">
        </div>
        <div class="sidebar-item cup">
          <img src="../../assets/image/gwc.png" alt="">
          <span class="icon1" v-if="getcartNumber > 0 && isOnline">{{ getCarCount }}</span>
        </div>
      </div>

      <div class="s2 cup" @click="scrollToTop">
        <div class="sidebar-item">
          <img src="../../assets/image/TOP.png" alt="">
        </div>
        <div class="text">TOP</div>
      </div>
    </div> -->

    <!-- 底部 -->
    <div class="foot" v-if="!hideHeaderFooter">

      <div class="f-h">
        <div class="copyright f-h-c">

          <div class="c-list">

            <div class="item" @click="gotoFuwenben(2, 'account')">
              <div class="itit">
                <div class="icon">
                  <img src="../../assets/image/f1.png" alt="account">
                </div>
                <div class="t">{{ $t('Account correlation') }}</div>
              </div>
              <div class="text" v-for="item in  bomList1">{{ item.question }}</div>
            </div>

            <div class="item" @click="gotoFuwenben(2, 'order')">
              <div class="itit">
                <div class="icon">
                  <img src="../../assets/image/f2.png" alt="account">
                </div>
                <div class="t">{{ $t('Order management') }}</div>
              </div>
              <div class="text" v-for="item in  bomList2">{{ item.question }}</div>
            </div>

            <div class="item" @click="gotoFuwenben(2, 'pay')">
              <div class="itit">
                <div class="icon">
                  <img src="../../assets/image/f3.png" alt="account">
                </div>
                <div class="t">{{ $t('Payment method') }}</div>
              </div>
              <div class="text" v-for="item in  bomList3">{{ item.question }}</div>
            </div>

            <div class="item" @click="gotoFuwenben(2, 'service')">
              <div class="itit">
                <div class="icon">
                  <img src="../../assets/image/f4.png" alt="account">
                </div>
                <div class="t">{{ $t('Customer service') }}</div>
              </div>
              <div class="text" v-for="item in  bomList6">{{ item.question }}</div>

              <div class="text" @click.stop="gotoFuwenben(1)">{{ $t('About Us') }}</div>
              <div class="text" @click.stop="getEmail">{{ $t('Contact us') }}</div>
            </div>
          </div>
        </div>

      </div>

      <div class="f-c disf copyright">

        <div class="l">
          <div class="item" style="margin: 0;">
            <div class="text">{{ $t('address') }}: {{ '4255 South Buckley Road #1296 Aurora CO 80013 USA' }}</div>
          </div>

          <div class="icons">
            <div class="icon" v-for="item in iconList">
              <a :href="item.link" target="_blank">
                <img :src="item.src">
              </a>
            </div>
          </div>
        </div>

        <div class="r">
          <div class="t">{{ $t('Download our app') }}</div>
          <div class="list disf">

            <div class="iit disf cup">
              <div class="l icon">
                <img src="../../assets/image/home/pg.png" alt="pg">
              </div>
              <div class="r">
                <div class="tt">{{ $t('Download it from') }}</div>
                <div class="t">APP STORE</div>
              </div>
            </div>

            <div class="iit disf cup">
              <div class="l icon">
                <img src="../../assets/image/home/gg.png" alt="gg">
              </div>
              <div class="r">
                <div class="tt">{{ $t('Download it from') }}</div>
                <div class="t">GOOGLE PLAY</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { Indicator, Toast } from 'mint-ui'
import { cartQuantity } from '../../api/homecart'
import { getAboutContent } from '../../api/homeArticle'
import { get_contact_info } from '../../api/homeindex'
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
export default {
  name: 'HomeBase',
  data() {
    return {
      lang: '',
      categories: [],
      home_selected: 'home_index',
      cartNumber: 0,

      bomList1: [],
      bomList2: [],
      bomList3: [],
      bomList4: [],
      bomList5: [],
      bomList6: [],
      bomList7: [],
      iconList: [
        {
          src: require('../../assets/image/home/b1.png'),
          type: 'Facebook'
        },
        {
          src: require('../../assets/image/home/b2.png'),
          type: 'Twitter'
        },
        {
          src: require('../../assets/image/home/b3.png'),
          type: 'YouTube'
        },
        {
          src: require('../../assets/image/home/b4.png'),
          type: 'Instagram'
        },
        {
          src: require('../../assets/image/home/b5.png'),
          type: 'LinkedIn'
        },
        {
          src: require('../../assets/image/home/b6.png'),
          type: 'TikTok'
        },
      ],
    }
  },
  computed: {
    ...mapGetters('settings', ['getLang']),
    ...mapGetters('settings', ['getcartNumber']),
    currentLang() {
      this.getAboutContents()
      if (this.utils.isJsonString(this.getLang)) {
        return this.utils.languageMap(JSON.parse(this.getLang));
      } else {
        return this.utils.languageMap(this.getLang);
      }
    },
    ...mapState({
      user: state => state.member.info,
      items: state => state.goodsclass.items,
      isOnline: state => state.member.isOnline,
      showSpecialFooter: state => state.home.showSpecialFooter
    }),
    showFooter() {
      if (this.$route.name == 'HomeIndex' || this.$route.name == 'HomeSpecial' || this.$route.name == 'HomeActivitydetail') {
        return this.showSpecialFooter
      } else {
        return true
      }
    },
    getCarCount() {
      if (this.getcartNumber > 0 && this.getcartNumber < 100 && this.isOnline) {
        return this.getcartNumber
      } else if (this.getcartNumber >= 100 && this.isOnline) {
        return '99+'
      } else {
        return '0'
      }
    },
    hideHeaderFooter() {
      return this.$route.meta.hideHeaderFooter || false
    }
  },
  created() {

    if (this.$route.query.inviter_id) {
      this.memberInviterId({ inviterId: this.$route.query.inviter_id })
    }
    // this.getCartCount()
    this.getGoodsclassList()
  },
  mounted() {
    // this.getAboutContents()
    get_contact_info().then(res => {
      // this.list = res.result.goods_list
      // 遍历 iconList 并添加 link 属性
      this.iconList.forEach(icon => {
        // 查找与 type 匹配的链接
        const link = res.data[icon.type];
        // 如果找到了链接，则添加到当前 icon 对象
        if (link) {
          icon.link = link;
        }
      });
    })
  },
  methods: {
    ...mapMutations({
      memberInviterId: 'memberInviterId'
    }),
    ...mapActions({
      fetchGoodsclassList: 'fetchGoodsclassList',
    }),
    ...mapActions('settings', ['ActionsCartNumber']),
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    goProduct(id, gc_name) {
      let params = { 'cate_id': id, 'gc_name': gc_name }
      this.$router.push({ 'name': 'HomeGoodslist', 'query': params })
    },
    getGoodsclassList() {
      if (!(this.items && this.items.length)) {
        Indicator.open()
      }
      this.fetchGoodsclassList().then((response) => {
        Indicator.close()
      }, (error) => {
        Toast(error.message)
        Indicator.close()
      })
    },
    gotoFuwenben(id, type) {
      this.$router.push({ name: 'HomeDocument', query: { id: id, type: type } })
    },
    getCartCount() {
      if (this.isOnline) {
        cartQuantity().then(res => {
          if (res) {
            this.cartNumber = res.result.cart_count
            this.ActionsCartNumber(this.cartNumber)
          }
        })
      }
    },
    getAboutContents() {

      getAboutContent('account').then(res => {
        this.bomList1 = res.result.list
      })
      getAboutContent('order').then(res => {
        this.bomList2 = res.result.list
      })
      getAboutContent('pay').then(res => {
        this.bomList3 = res.result.list
      })
      getAboutContent('shipping').then(res => {
        this.bomList4 = res.result.list
      })
      getAboutContent('refund').then(res => {
        this.bomList5 = res.result.list
      })
      getAboutContent('service').then(res => {
        this.bomList6 = res.result.list
      })
      getAboutContent('security').then(res => {
        this.bomList7 = res.result.list
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.guide {
  position: relative;
  .guide-box {
    display: none;
    overflow: scroll;
    box-sizing: border-box;
    background: #FFFFFF;
    position: absolute;
    top: 46px;
    z-index: 99;
    font-size: 13px;
    color: #666666;
    &::-webkit-scrollbar {
      display: none;
    }

    .category-item {
      box-sizing: border-box;
      background: #ef4618;
      padding: 12px 18px;
      text-align: center;
      color: #fff;
      cursor: pointer;
      &:hover {
        color: #FFFFFF;
        background: #EF4618;
      }
    }
  }
}
.guide:hover .guide-box {
  display: grid !important;
  gap: 1px;
  z-index: 999;
}
.head {
  width: 100%;
  border-bottom: 1px solid #EF4618;
  background: #FFFFFF;

  .h-t-b {
    background: #333333;
  }

  .h-t,
  .h-c,
  .h-f {
    width: 1200px;
    margin: 0 auto;
  }

  .h-t {
    padding: 15px 0 12px;
    font-size: 12px;
    line-height: 11px;

    .l {
      color: #969696;
    }

    .r {
      color: #FFFFFF;

      .lang {
        margin: 0 10px 0 15px;
        position: relative;

        &::after {
          content: '';
          position: absolute;
          top: 50%;
          right: -10px;
          transform: translateY(-50%);
          // background: #BDBDBD;
          display: block;
          width: 0;
          height: 0;
          border-left: 4px solid transparent;
          border-right: 4px solid transparent;
          border-top: 4px solid #BDBDBD;
        }
      }
    }
  }

  .h-c {
    align-items: flex-start;
    margin: 36px auto 33px;

    .l {
      width: 163px;
      height: 50px;

      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }

    .r {
      .search {
        display: flex;
        align-items: center;

        .input {
          input {
            box-sizing: border-box;
            padding: 15px 12px;
            width: 410px;
            height: 44px;
            border: 1px solid #EF4618;
            border-radius: 4px 0 0 4px;
            background: #FFFFFF;
          }
        }

        .s-btn {
          width: 68px;
          height: 44px;
          background: #EF4618;
          border-radius: 0px 4px 4px 0px;
          justify-content: center;

          img {
            width: 16px;
            height: 16px;
            display: block;
          }
        }
      }

      .s-tips {
        margin: 8px 12px;
        font-size: 12px;
        color: #B8B8B8;
      }
    }
  }

  .h-f {
    .l {
      .all {
        box-sizing: border-box;
        height: 45px;
        padding: 20px 18px;
        font-size: 16px;
        color: #FFFFFF;
        background: #EF4618;
        position: relative;

        &:hover .category-list {
          display: block;
          /* 当鼠标悬停在容器上时显示列表 */
        }

        .icon {
          width: 20px;
          height: 16px;

          img {
            width: 100%;
            height: 100%;
            display: block;
          }
        }

        .text {
          font-size: 18px;
          margin: 0 35px 0 10px;
        }

        .category-list {
          display: none;
          width: 100%;
          height: 460px;
          overflow: scroll;
          box-sizing: border-box;
          background: #FFFFFF;
          position: absolute;
          top: 46px;
          left: 0;
          z-index: 99;
          font-size: 13px;
          color: #666666;
          padding: 1px 1px;

          &::-webkit-scrollbar {
            display: none;
          }

          .category-item {
            padding: 13px 16px;

            &:hover {
              color: #FFFFFF;
              background: #EF4618;
            }
          }
        }
      }

      .common-footer {
        box-sizing: border-box;
        height: 45px;
        line-height: 45px;
        background: #fff;

        .item-wrap {
          box-sizing: border-box;
          height: 45px;
          line-height: 45px;
          display: flex;
          align-items: center;
          margin: 0 10px 0 35px;
          background: #fff;

          .category-list {
            display: none;
          }

          span {
            font-size: 18px;
            color: #333333;
          }
        }

        .active {
          position: relative;

          span {
            color: #EF4618;
          }

          &::after {
            content: '';
            position: absolute;
            bottom: 7px;
            left: 0;
            width: 100%;
            height: 4px;
            background: linear-gradient(90deg, #EF4618 0%, rgba(239, 70, 24, 0) 100%);
            border-radius: 2px;
          }
        }
      }
    }

    .r {
      .icon {
        width: 21px;
        height: 21px;
      }

      .text {
        margin-left: 10px;
        font-size: 14px;
        color: #EF4618;
      }
    }
  }
}

.layout-view {
  padding-bottom: 1px;
  background: #F1F3F5;

  .home-view {
    width: 1200px !important;
    min-height: calc(100vh - 688px);
    margin: 20px auto;
  }
}

.shortcut {
  right: 0;
  top: 0;
  left: 0;
  // position: fixed;
  z-index: 99;
  background: #e3e4e5;
}

.common-footer-wrap {
  margin: auto;
  width: 1210px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .common-footer {
    background: #e3e4e5 !important;
  }

  .username {
    font-size: .6rem;
    line-height: .6rem;
    color: #666;
  }
}

.foot {
  background: #F1F5F7;

  .copyright {
    width: 1200px;
    margin: 0 auto;
    font-size: $fontSize;
    color: #c5c5c5;
    text-align: center;
    padding: 1rem 0;

    .c-list {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
    }

    .item {
      padding: .4rem 0;
      margin: 0 .2rem 1rem 0;

      .t {
        // margin-bottom: .4rem;
        text-align: left;
        font-size: .6rem;
        color: #4b4b4b;
        font-weight: 600;
      }

      .text {
        cursor: pointer;
        text-align: left;
        font-size: .6rem;
        margin: .5rem 0;
        color: #7F7F7F;
      }
    }

    .icons {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .icon {
        cursor: pointer;
        width: 28px;
        height: 28px;
        margin-right: 15px;

        img {
          width: 100%;
          height: 100%;
          display: block !important;
        }
      }
    }

    .link {
      color: #c5c5c5
    }
  }

  .f-h {
    background: #fff;

    .f-h-c {
      padding: 30px 0 90px;

      .itit {
        display: flex;

        .icon {
          width: 16px;
          height: 16px;
          margin-right: 8px;
        }

        .t {
          font-size: 16px;
          color: #333333;
        }
      }

      .text {
        margin-left: 24px;
        color: #999999;
        font-size: 14px;

        &:hover {
          color: #333333;
        }
      }
    }
  }

  .f-c {
    background: #F1F5F7;

    .r {
      .t {
        font-size: 18px;
        color: #222222;
        text-align: right;
        margin-bottom: 10px;
      }
    }

    .list {
      .iit {
        box-sizing: border-box;
        padding: 20px 22px;
        margin-left: 16px;
        width: 271px;
        height: 84px;
        background: #FFFFFF;
        border-radius: 8px;

        .icon {
          width: 35px;
          height: 40px;
        }

        .tt {
          font-size: 17px;
          color: #999999;
        }

        .t {
          font-size: 17px;
          font-weight: bold;
          color: #333333;
        }
      }
    }
  }
}

.item-wrap {
  position: relative;
  white-space: nowrap;
  margin: 0 .5rem;

  &:hover {
    .text {
      color: #e93b3d !important;
    }
  }
}

.category {
  position: relative;

  &:hover {
    .category-list {
      display: grid !important;
      grid-template-columns: repeat(2, 1fr);
      gap: 30px;
    }
  }

  .category-list {
    display: none;
    width: 798px;
    height: 400px;
    border-radius: 12px;
    border: 1px solid #BBBBBB;
    overflow: scroll;
    box-sizing: border-box;
    background: #FFFFFF;
    position: absolute;
    top: 46px;
    left: -10px;
    z-index: 99;
    font-size: 13px;
    color: #666666;
    padding: 42px 49px;

    &::-webkit-scrollbar {
      display: none;
    }

    .category-item {
      width: 312px;
      height: 49px;
      box-sizing: border-box;
      background: #F6F6F6;
      border-radius: 25px;
      padding: 18px 0;
      text-align: center;

      &:hover {
        color: #FFFFFF;
        background: #EF4618;
      }
    }
  }
}

.image {
  width: 1rem;
  height: 1rem;
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top: .2rem;
  margin-bottom: .2rem;
}

.icon1 {
  position: absolute;
  right: 0;
  top: 0;
  transform: translate(50%, -35%);
  text-align: center;
  width: 18px;
  height: 18px;
  padding: 2px;
  line-height: 18px;
  background: #EF4618;
  border-radius: 50%;
  font-size: 12px;
  color: #FFFFFF;
}


::v-deep(.mint-tabbar) {
  position: relative;
}

img {
  width: 100%;
  height: 100%;
  display: block;
}

.sidebar {
  position: fixed;
  right: 226px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  z-index: 999;

  .s1 {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    box-sizing: border-box;
    padding: 14px 16px;
    width: 60px;
    height: 115px;
    background: #FFFFFF;
    box-shadow: 0px 3px 13px 0px rgba(144, 144, 144, 0.3);
    border-radius: 4px;

    .sidebar-item {
      width: 26px;
      height: 26px;
      position: relative;
    }
  }

  .s2 {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    padding: 14px 16px;
    margin-top: 18px;
    width: 60px;
    height: 47px;
    background: #FFFFFF;
    box-shadow: 0px 3px 13px 0px rgba(144, 144, 144, 0.31);
    border-radius: 4px;

    .sidebar-item {
      width: 20px;
      height: 12px;
      margin-bottom: 5px;
    }

    .text {
      font-size: 12px;
      color: #EF4618;
      text-align: center;
    }
  }
}
</style>
